/**
 * Labstep
 *
 * @module components/EntityImport/Table/Container
 * @desc EntityImport table read container
 */

import { Action } from 'labstep-web/components/EntityImport/Action/Menu';
import { EntityImportTable } from 'labstep-web/components/EntityImport/Table';
import { ReadOnMountHOC } from 'labstep-web/hoc/ReadOnMount';
import { useActiveGroup } from 'labstep-web/hooks/activeGroup';
import { EntityImport } from 'labstep-web/models/entity-import.model';
import type React from 'react';
import type { EntityImportTableContainerProps } from './types';

export const EntityImportTableContainer: React.FC<
  EntityImportTableContainerProps
> = ({ targetEntityName, params, actions = [Action.revert] }) => {
  const { activeGroup } = useActiveGroup();
  if (!activeGroup) {
    return null;
  }
  return (
    <ReadOnMountHOC
      type="cursor"
      params={{
        group_id: activeGroup.id,
        target_entity_name: targetEntityName,
        ...params,
      }}
      entityName={EntityImport.entityClass}
      children={({ entities }): React.ReactElement => (
        <EntityImportTable
          entityImports={entities}
          actions={actions}
        />
      )}
    />
  );
};
